<script lang="ts">
    import { Button, Icon, Input, Label } from "sveltestrap";
    import { directionsService, uiService } from '../services';
    import { geolocationStreetService } from "../services";
    import MapView from "./MapView.svelte";
    import UserMarker from "./UserMarker.svelte";
    import ParamSelect from "./ParamSelect.svelte";
    import {v4 as uuidv4} from "uuid";
    import { Direction } from "../Model/Direction";

    export let directionId:string;
    let direction = null;

    $: loadDirection();

    async function loadDirection(): Promise<void> {
        
        if (!directionId) {
            newDirection();
            return;
        }

        await directionsService.findOne(directionId).then(response => {
            if (response.errorMessage == "La dirección no ha sido encontrado.") {
                newDirection();
                return;
            }
            
            direction = response

        }).catch((error) => {
            console.log(error)
        }) 

    } 

    function newDirection(){
        direction = (new Direction({
            id: directionId,
            streetId: null,
            streetTypeId: null,
            number: 0,
            districId: null,
            portal: '',
            stairs: '',
            floor: '',
            door: '',
            complexId: null,
            buildingId: null,
            municipalityId: null,
            provinceId: null,
            countryId: null,
            coords: null
        })).getState();

        // directionId = direction.id;
    }

    async function geolocationStreetToCoords(): Promise<void>{
        
        if (!direction.streetId) return;

        direction.coords =  await geolocationStreetService.streetToCoords(direction);
        
    }

    export async function saveDirection(){
        if(!direction.id) {
            direction.id = uuidv4();
        }
        await geolocationStreetToCoords();

        if (!direction.streetId) return;
        try {
            await directionsService.saveDirection(direction);
            await uiService.notifySuccess('Dirección Guardada Correctamente')
            alert('Dirección guardada');
        } catch (error) {
            uiService.notifyError('Error al Guardar una dirección')
        }
       

    }

</script>

<style>

    .map-view-container{
        height: 300px;
    }

</style>

{#if direction}
    <div class="row">
        <div class="col-12 col-sm-3 mb-3">
            <Label for="phone2">Tipo Calle</Label>
            <ParamSelect
                bind:paramSelectId = {direction.streetTypeId}
                paramType = 'streetType'
                nothing = {true}
            />
        </div>
        <div class="col-12 col-sm-7 mb-3">
            <Label for="phone2">Calle</Label>
            <ParamSelect 
                bind:paramSelectId = {direction.streetId}
                paramType = 'street'
                nothing = {true}
            />
        </div>
        <div class="col-12 col-sm-2 mb-3">
            <Label for="name">Número</Label>
            <Input type="number" bind:value={direction.number} />
        </div>
        <div class="col-12 col-sm-6 mb-3">
            <Label for="surname1">Urbanización</Label>
            <ParamSelect
                bind:paramSelectId = {direction.complexId}
                paramType = 'complex'
                nothing = {true}
            />
        </div>
        <div class="col-12 col-sm-6 mb-3">
            <Label for="surname1">Edificio</Label>
            <ParamSelect 
                bind:paramSelectId = {direction.buildingId}
                paramType = 'building'
                nothing = {true}
            />
        </div>
        <div class="col-12 col-sm-3 mb-3">
            <Label for="name">Portal</Label>
            <Input type="text" bind:value={direction.portal} />
        </div>
        <div class="col-12 col-sm-3 mb-3">
            <Label for="name">Escalera</Label>
            <Input type="text" bind:value={direction.stairs} />
        </div>
        <div class="col-12 col-sm-3 mb-3">
            <Label for="name">Piso</Label>
            <Input type="text" bind:value={direction.floor} />
        </div>
        <div class="col-12 col-sm-3 mb-3">
            <Label for="name">Puerta</Label>
            <Input type="text" bind:value={direction.door} />
        </div>
        <div class="col-12 col-sm-4 mb-3">
            <Label for="municipality">Municipio</Label>
            <ParamSelect 
                bind:paramSelectId = {direction.municipalityId}
                paramType = 'municipality'
                nothing = {true}
            />
        </div>
        <div class="col-12 col-sm-4 mb-3">
            <Label for="provinceId">Provincia</Label>
            <ParamSelect 
                bind:paramSelectId = {direction.provinceId}
                paramType = 'province'
                nothing = {true}
            />
        </div>
        <div class="col-12 col-sm-4 mb-3">
            <Label for="countryId">País</Label>
            <ParamSelect 
                bind:paramSelectId = {direction.countryId}
                paramType = 'country'
                nothing = {true}
            />
        </div>

        {#if direction.coords && direction.coords}
            <div class="col-12">
                <div class="map-view-container mb-3">
                    <MapView center={direction.coords}>
                        <UserMarker bind:location={direction.coords} />
                    </MapView>
                </div>
            </div>
        {/if}
    </div>

    <Button color="primary" on:click={saveDirection}>Guardar dirección</Button>
   
{/if}



